import { Helmet } from 'react-helmet';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useScript from '../../../hooks/useScript';
import * as actions from '../../../redux/actions';
import { getAuthInfo, getIsAdmin } from '../../../redux/selectors';

import { Wrapper, User, ListItem } from './UserPopover.stc';

function UserPopover({ user }) {
    const match = useRouteMatch();
    const dispatch = useDispatch();
    const auth = useSelector(getAuthInfo);
    const isAdmin = useSelector(getIsAdmin);

    useScript('https://apis.google.com/js/platform.js?onload=onLoadGAPI');

    const handleLogout = useCallback(() => {
        if (auth.provider === 'google') {
            const auth2 = window.gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                dispatch(actions.logout());
            });
        } else {
            dispatch(actions.logout());
        }
    }, [auth.provider, dispatch]);

    useEffect(() => {
        if (auth.provider === 'google') {
            window.onLoadGAPI = function () {
                window.gapi.load('auth2', function () {
                    window.gapi.auth2.init();
                });
            };
        }
    }, [auth.provider]);

    return (
        <Wrapper>
            <Helmet>
                <meta
                    name="google-signin-client_id"
                    content="1039322478589-a7g40127ubiog8vorh8c3llj999e92st.apps.googleusercontent.com"
                ></meta>
            </Helmet>
            <User>
                <div className="name">
                    <strong>{user.name}</strong>
                </div>
                <div className="email">{user.email}</div>
            </User>
            <ul className="unstyle">
                <ListItem>
                    <Link to="/dashboard/account">
                        <FontAwesomeIcon
                            fixedWidth
                            className="mr-15"
                            icon={['far', 'user-circle']}
                        />
                        Account Settings
                    </Link>
                </ListItem>
                {isAdmin && (
                    <ListItem>
                        <Link to={match.path + '/admin'}>
                            <FontAwesomeIcon
                                fixedWidth
                                className="mr-15"
                                icon={['far', 'user-shield']}
                            />
                            Admin Panel
                        </Link>
                    </ListItem>
                )}
                {/* <ListItem>
                    <Link to="/dashboard/logs">
                        <FontAwesomeIcon
                            fixedWidth
                            className="mr-15"
                            icon={['far', 'clipboard-list']}
                        />
                        Change Log
                    </Link>
                </ListItem> */}
                <ListItem>
                    <a href="#" onClick={handleLogout}>
                        <FontAwesomeIcon
                            fixedWidth
                            className="mr-15"
                            icon={['far', 'sign-out']}
                        />
                        Sign Out
                    </a>
                </ListItem>
            </ul>
        </Wrapper>
    );
}

export default UserPopover;
